import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from 'src/environments/environment';
import {finalize} from 'rxjs/operators';
import {LoaderService} from './loader.service';
import {ProfileService} from './http/profile.service';
import {Profile} from './http/interfaces/profile.interface';
import {AuthService} from './auth.service';

@Injectable({
    providedIn: 'root',
})
export class UserService {
    /**
     * API URL
     * @private
     */
    private readonly apiUrl = environment.apiUrl;

    /**
     * Key user profile session storage
     * @private
     */
    private readonly KEY_USER_PROFILE = 'user_profile';

    /**
     * Active profile logged into the system
     * @public
     */
    public activeProfile: Profile;

    /**
     * Constructor
     * @param http - Angular Http Client
     * @param profileService - Profile Service
     * @param auth - Auth service
     * @param loader - Loader Service
     */
    constructor(
        private http: HttpClient,
        private profileService: ProfileService,
        private auth: AuthService,
        private loader: LoaderService
    ) {
    }

    /**
     * Request user profile from session storage
     * If not exists get profile from API
     * @param forceUpdate - Force reload profile (default false)
     */
    public getProfile(forceUpdate: boolean = false): Promise<any> {
        return new Promise<any>(resolve => {
            let profile = sessionStorage.getItem(this.KEY_USER_PROFILE);

            if (!profile || forceUpdate) {
                this.loader.show();
                this.profileService.getProfile().pipe(finalize(() => this.loader.hide())).subscribe((response: any) => {
                    const activeProfile: Profile = response.perfil;
                    activeProfile.imageUrl = !!activeProfile.foto ? `${environment.apiUrl}${activeProfile.foto}?r=${Math.random()}` : undefined;
                    this.activeProfile = activeProfile;
                    sessionStorage.setItem(this.KEY_USER_PROFILE, JSON.stringify(activeProfile));
                    resolve(response.perfil);
                });
            } else {
                this.activeProfile = JSON.parse(profile);
                resolve(this.activeProfile);
            }
        })
    }
}
